/**
 * Created by cd on 25.05.17.
 */

export const API_DATA_LOADED = 'API_DATA_LOADED';
export const INIT_DB = 'INIT_DB';
export const COMMIT_DB = 'COMMIT_DB';


export function commitDb(db) {
    return {
        type: COMMIT_DB,
        value: db
    }
}

export function initDb(initialState) {
    return {
        type: INIT_DB,
        value: initialState
    }
}

export function apiGet(url, db) {
    return function(dispatch, getState) {
        fetch(url)
            .then(function(response) {
                return response.json()
            }).then(function(json) {
            dispatch({
                type: API_DATA_LOADED,
                value: {
                    orm: db.orm,
                    data: json.data,
                    meta: json.meta
                }
            })
        }).catch(function(error) {
            dispatch({
                type: 'ERR_DATA_LOADED'
            })
        });
    }
}



// WEBPACK FOOTER //
// ./src/lib/worm/actions.js